import { DarkModeButton, FloatingWidgets, Footer, NavBar } from 'src/components/_commons';
import { Outlet, Route, Routes } from 'react-router-dom';
import { RouterWithNav } from './RouterWithNav';
import { useGetIsMobile } from 'src/custom-hooks';
import * as Pages from '../components';

export const MainRouter = () => {
    const isMobile = useGetIsMobile();

    const NoNavLayout = ({ isMobile }: { isMobile: boolean }) => {
        return (
            <div
                style={{
                    maxWidth: isMobile ? "95%" : "90%",
                    paddingBottom: "10px",
                    paddingTop: "10px",
                    margin: "auto",
                    minHeight: "100vh",
                }}
            >
                <Outlet />
            </div>
        );
    }

    return (
        <Routes>
            <Route element={<NoNavLayout isMobile={isMobile} />}>
                <Route
                    element={<Pages.FreeAVUshersPage />}
                    path={'/audio-video-acomodadores/:congregation'}
                />
                <Route
                    element={<Pages.FreeCartsPage />}
                    path={'/carritos/:congregation'}
                />
                <Route
                    element={<Pages.FreeCleaningPage />}
                    path={'/limpieza-del-salon/:congregation'}
                />
            </Route>
            <Route path={'*'} element={
                <>
                    <div style={{ position: 'fixed', width: '100%', zIndex: 4 }}>
                        <NavBar />
                        <FloatingWidgets />
                        {/* {sse.OPEN !== EventSource.OPEN &&
                            <div style={{ marginTop: '30px', position: 'fixed', zIndex: 4 }}>
                                <WarningToaster
                                    bodyText={'Refrescar la página y verificar que hay internet'}
                                    headerText={<strong>Hay un problema de conexión</strong>}
                                />
                            </div>
                        } */}
                    </div>
                    <div style={{
                        maxWidth: isMobile ? '95%' : '90%',
                        paddingTop: '75px',
                        margin: 'auto',
                        minHeight: 'calc(100vh - 80px)'
                    }}>
                        <RouterWithNav />
                        <DarkModeButton />
                    </div>
                    <Footer />
                </>
            } />
        </Routes>
    );
}
